import React, { useState, useEffect } from "react";
import axios from "axios";
import MainLogo from "../../assets/image/logo-image.png";

const FrontPage = () => {
  const [homeCenterImage, setHomeCenterImage] = useState("");

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_END_POINT}/get-registration-visibility`)
      .then((res) => {
        if (res.data.data && res.data.data.home_background) {
          setHomeCenterImage(res.data.data.home_background);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  const homeCenterSrc = homeCenterImage
    ? `${process.env.REACT_APP_IMAGE_URL}/branding/${homeCenterImage}`
    : MainLogo;

  return (
    <div className="text-center">
      <h1 className="display-1">Welcome</h1>
      <h1 className="display-4">to</h1>
      <img src={homeCenterSrc} className="img-fluid" alt="Main Logo" style={{ maxWidth: '512px', maxHeight: '512px', objectFit: 'contain' }} />
    </div>
  );
};

export default FrontPage;
